import {Layout} from '../../../layout'
import {useBasicTableContext} from '../../context'
import {BasicTableHeaderCell} from './cell'
import './index.less'

export const BasicTableHeader = () => {
	const {columns, hideHeader} = useBasicTableContext()

	if (hideHeader) return null

	return (
		<Layout
			className="basic-table-header"
			gap={1} // using gap to create the visual separation without affecting the width of elements
			width="full"
			sticky="0 - - -"
			border
			background="medium-border"
		>
			{columns.map(column => (
				<BasicTableHeaderCell key={column.id} column={column} />
			))}
		</Layout>
	)
}
